// @flow

import * as React from "react";

import type { Location } from "react-router";
import Page from "../../components/Page/Page";

type Props = {
  location: Location
};

const NotFound = (props: Props) => (
  <Page className="NotFound">
    <h3>
      Uh-oh... <code>{props.location.pathname}</code> was not found.
    </h3>
  </Page>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js